/**
 * banner
 * @returns ReactElement
 */
import { Button, Skeleton } from '@bfe/moly';
import { useFm, useParams } from '@web3/base-hooks';
import { ArrowchevronRightIcon } from '@bfe/moly-icons';
import { useScreenType } from '@/hooks/media';
import Link from 'next/link';
import { useEffect } from 'react';
import { useHomeStore } from '@/store/home';
import { isApp, appPath } from '@web3/base-utils';
import { Page } from '@/config/track-config';
import cls from 'classnames';

import styles from './index.module.scss';
import SparkleIcon from '@/assets/svg/home/sparkle.svg';

interface Props {
  eligibilityCount: number;
}

export function Banner(props: Props) {
  const { eligibilityCount } = props;
  const { isMobile } = useScreenType();
  const { locale } = useParams();
  const fm = useFm();
  const homeStore = useHomeStore();

  useEffect(() => {
    !isApp() && homeStore.fetchBannerList();
  }, []);

  return (
    <div className="home-banner relative text-white">
      <div
        className={cls([
          'main flex justify-between gap-6',
          isMobile
            ? 'home-banner-h5 px-4'
            : 'home-banner-web mt-[43px] text-white',
        ])}
      >
        <div className="flex flex-col gap-4 !md:gap-8 justify-center h-full">
          <div className="title-box">
            <h1 dangerouslySetInnerHTML={{ __html: fm('airdropArcade') }}></h1>
            <h2 className="mt-2 text-2xl font-500 subtitle">
              {fm('airdrop_sub_title')}
            </h2>
          </div>
          {!(isApp() || isMobile) && (
            <div className="flex gap-4 guide-btn">
              <Button
                variant="secondary"
                size="large"
                className={cls({
                  [styles.button]: !!eligibilityCount,
                })}
                onClick={() => {
                  window.open(`/${locale}${appPath}/rewards`, '_blank');
                }}
                data-spm-even="Web3UserClick"
                data-spm-data={JSON.stringify({
                  page_name: Page.AirdropArcadeHome,
                  button_name: 'MyRewards',
                })}
              >
                <img
                  src={`${appPath}/images/home/icon-myreward.svg`}
                  alt="my rewards"
                  className="transition-all"
                />
                {fm('myRewards')} <ArrowchevronRightIcon />
                {!!eligibilityCount && (
                  <SparkleIcon className={styles.sparkle} />
                )}
              </Button>
            </div>
          )}
        </div>

        {!isMobile ? (
          <div
            className={`${styles.activityCard} w-full h-full !md:w-[640px] relative rounded overflow-hidden`}
          >
            {!homeStore.bannerDataIsReady && (
              <Skeleton.Bar
                style={{
                  width: 640,
                  height: 320,
                }}
              />
            )}
            {homeStore.bannerDataIsReady &&
              homeStore.bannerData?.banner?.slice(0, 1).map(
                (item) =>
                  item.web_image &&
                  item.link && (
                    <div key={item.web_image.uid} className="h-full">
                      <Link
                        href={item.link.href}
                        target="_blank"
                        data-spm-even="Web3UserClick"
                        data-spm-data={JSON.stringify({
                          page_name: Page.AirdropArcadeHome,
                          button_name: 'Banner',
                        })}
                      >
                        <img
                          width={640}
                          height={320}
                          className="h-full"
                          src={item.web_image.url}
                          alt=""
                        />
                      </Link>
                    </div>
                  )
              )}
          </div>
        ) : (
          <img
            className="w-30 h-30 mt-12"
            src="https://fh-static.bycsi.com/airdrop-banner-h5bg-ed93e0c5ae8c85aa8324bfbdf5c36de8.png"
            alt=""
          />
        )}
      </div>
    </div>
  );
}
